import React, {useState} from "react"
import { ValidationError } from "./styled";

const InputForProperty = ({type = 'text', header, value, validationError, onChange, ...other}) => {

    return (
        <>
            {header && <label>{header}</label>}
            {validationError && <ValidationError>{validationError}</ValidationError>}
            <input {...other} type={type} 
                onChange={(e) => onChange(e.target.value, e)} value={value || ''}
                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }} />
        </>
    )
}

export default InputForProperty;